import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const CommonSection = styled(Box)(({ theme }) => ({
  position: "relative",
  padding: "1rem 16px",
  borderRadius: "24px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.72) 0%, rgba(248,243,236,0.70) 100%)",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.8)",
  [theme.breakpoints.up("sm")]: {
    padding: "1rem 40px !important",
  },
  [theme.breakpoints.up("md")]: {
    padding: "1rem 60px !important",
  },
  [theme.breakpoints.up("lg")]: {
    padding: "1rem 80px !important",
  },
  [theme.breakpoints.up("xl")]: {
    padding: "1rem 100px",
  },
}));
